
import { Component, Prop, Vue } from 'bits/vue'

@Component({})
export default class OzLoadingText extends Vue {
  @Prop({ default: 'auto' }) darkMode!: true | false | 'auto'
  @Prop() text!: string
}
